<div class="row">
    <div [ngClass]="(crossBorderLoad | json) != '{}' ? 'col-sm-6' : 'col-sm-12'">
        <kendo-expansionpanel [title]="'Cross Border Orders'"
                              [subtitle]="''"
                              [expanded]="true">
            <kendo-grid #crossBorderGrid
                        [data]="gridData"
                        [pageSize]="gridState.take"
                        [skip]="gridState.skip"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        [selectable]="true"
                        [resizable]="true"
                        [autoSize]="true"
                        [rowClass]="rowCallback"
                        (selectionChange)="rowSelected($event)"
                        (dataStateChange)="gridStateChange($event)"
                        (filterChange)="filterChange($event)">
                <kendo-grid-column field="orderNumber" title="Order Number">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div style="white-space:nowrap;">
                            <a target="_blank" [routerLink]="['/order-entry', dataItem.quoteOrderID]">{{dataItem.orderNumber}}-{{ dataItem.legNumber}}</a>
                            <a [routerLink]="" (click)="viewOrder(dataItem)"><i class="fas fa-angle-double-right fa-lg p-2"></i></a>
                            <span style="margin-left:5px;"><i class="fas fa-circle fa-lg" [ngClass]="{'text-danger': dataItem.minutesUntilDue <= 0, 'text-warning': dataItem.minutesUntilDue > 0 && dataItem.minutesUntilDue <= 15, 'text-primary': dataItem.minutesUntilDue > 15 && dataItem.minutesUntilDue <= 30, 'text-success': dataItem.minutesUntilDue > 30}"></i></span>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <!--<kendo-grid-column field="crossBorderDirection" title="Direction">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>-->
                <kendo-grid-column field="legCntryToCntry" title="Cntry-To-Cntry">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-multiselect [data]="c2cList"
                                           [autoClose]="false"
                                           [valuePrimitive]="true"
                                           [value]="c2cFilters(filter)"
                                           style="width:100px;height:33.5px;"
                                           (valueChange)="c2cChange($event)">
                        </kendo-multiselect>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="logisticSpecialist" title="Logistic Specialist">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-multiselect [data]="logisticSpecialists"
                                           textField="fullName"
                                           valueField="fullName"
                                           [autoClose]="false"
                                           [valuePrimitive]="true"
                                           [value]="logisticSpecialistsFilters(filter)"
                                           style="width:140px;height:33.5px;"
                                           (valueChange)="logisticSpecialistsChange($event)">
                        </kendo-multiselect>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="carrierCode" title="Carrier Code">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                            {{dataItem.carrierCode}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="csrName" title="CSR">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="trailerNumber" title="Trailer #">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="pickupDate" title="Pickup Date">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-date-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.pickupDate | date: 'M/dd/yyyy HH:mm'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="crossingDate" title="Crossing Date">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-date-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.crossingDate | date: 'M/dd/yyyy HH:mm'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="deliveryDate" title="Delivery Date">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-date-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.deliveryDate | date: 'M/dd/yyyy HH:mm'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="deliveryHasAppointment" title="Has Appt?">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-boolean-filter-cell [column]="column" [filter]="filter"></kendo-grid-boolean-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" [checked]="dataItem.deliveryHasAppointment" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="orderShipperCustomerName" title="Order Shipper">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/customer-detail', dataItem.orderShipperCustomerCode]">
                            {{dataItem.orderShipperCustomerName}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderShipperCustomerCode" title="Shipper Code">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/customer-detail', dataItem.orderShipperCustomerCode]">
                            {{dataItem.orderShipperCustomerCode}}
                        </a><br />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderShipperCity" title="O City">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderShipperCity}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderShipperSTAbbr" title="O ST">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderShipperSTAbbr}}
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="orderConsigneeCustomerName" title="Order Consignee">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/customer-detail', dataItem.orderConsigneeCustomerCode]">
                            {{dataItem.orderConsigneeCustomerName}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderConsigneeCustomerCode" title="Consignee Code">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/customer-detail', dataItem.orderConsigneeCustomerCode]">
                            {{dataItem.orderConsigneeCustomerCode}}
                        </a><br />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderConsigneeCity" title="D City">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderConsigneeCity}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderConsigneeSTAbbr" title="D ST">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderConsigneeSTAbbr}}
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="billToCustomerName" title="Bill To">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/customer-detail', dataItem.billToCustomerCode]">
                            {{dataItem.billToCustomerName}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="billToCustomerCode" title="Bill To Code">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/customer-detail', dataItem.billToCustomerCode]">
                            {{dataItem.billToCustomerCode}}
                        </a><br />
                    </ng-template>
                </kendo-grid-column>
                <!--<kendo-grid-column field="billToCity" title="Bill To City">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.billToCity}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="billToSTAbbr" title="Bill To ST">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.billToSTAbbr}}
        </ng-template>
    </kendo-grid-column>-->
                <kendo-grid-column field="lastCheckCallNote" title="Recent Comment">
                    <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
                        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
                    </ng-template>
                </kendo-grid-column>
                <!--<kendo-grid-column field="originCountryAbbreviation" title="O-Cntry">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-multiselect [data]="countries"
                               [autoClose]="false"
                               [valuePrimitive]="true"
                               [value]="countryFilters(filter, 'origin')"
                               style="width:50px;height:33.5px;"
                               (valueChange)="countryChange($event, 'origin')">
            </kendo-multiselect>
        </ng-template>
    </kendo-grid-column>-->
                <!--<kendo-grid-column field="destinationCountryAbbreviation" title="D-Cntry">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-multiselect [data]="countries"
                               [autoClose]="false"
                               [valuePrimitive]="true"
                               [value]="countryFilters(filter, 'destination')"
                               style="width:50px;height:33.5px;"
                               (valueChange)="countryChange($event, 'destination')">
            </kendo-multiselect>
        </ng-template>
    </kendo-grid-column>-->
                <!--<kendo-grid-column field="trailerAbbreviation" title="Trailer Type">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" [showOperators]="false"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>-->
            </kendo-grid>
        </kendo-expansionpanel>
    </div>

    <div *ngIf="(crossBorderLoad | json) != '{}'" [ngClass]="(crossBorderLoad | json) != '{}' ? 'col-sm-6' : 'col-sm-12'">
        <cross-border-form [crossBorderLoad]="crossBorderLoad" (onRefresh)="cancelView()"></cross-border-form>
    </div>
</div>
